// extracted by mini-css-extract-plugin
export default {"table":"Clipart_table__nx5E4","color":"Clipart_color__5W8Cu","sec":"Clipart_sec__z28NN"};